import React from 'react';
import { Stack } from '@mui/material';

function EnquiryCtas({ sx = {}, children }) {
  return (
    <Stack
      sx={{
        pt: 2,
        pb: 1,
        background: '#fff',
        ...sx,
      }}
      spacing={1}
      direction='column'
      alignItems='center'
      justifyContent='start'>
      {children}
    </Stack>
  );
}

export default EnquiryCtas;
